import React, { useState, useEffect } from 'react';
import { Box, Button, CircularProgress, Typography, TextField } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import Delete from '../assets/icons/primary-blue-bin.png'
import colors from '../CustomizedUIs/Colors'
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import { Link, useHistory } from 'react-router-dom'

const InfoChannels = ({ setOpenDetail, openDetailInfoChannel, clusterData, permissions }) => {
    const dataProvider = useDataProvider()
    const translate = useTranslate()
    const history = useHistory();
    const [data, setData] = useState([])
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [loading, setLoading] = useState(false)


    const handleClickReName = (name, index) => {
        let temps = data.slice()
        temps[index].edit = true
        temps[index].editName = name
        setData(temps)
    }

    const onCancel = (index) => {
        let temps = data.slice()
        temps[index].edit = false
        delete temps[index].editName
        setData(temps)
    }

    const handleOnDelete = () => {
        if (openConfirmDialog.index > -1) {
            dataProvider('DELETE', "infochannels", {
                id: data[openConfirmDialog.index].id
            })
                .then(() => {
                    let temps = data.slice()
                    temps.splice(openConfirmDialog.index, 1)
                    setData(temps)
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }

    }

    const handleOutFocus = (value, index) => {
        if (value.length > 0) {
            var temps = data.slice()
            if (data[index].name === data[index].editName) {
                temps[index].edit = false
                setData(temps)
            }
            else {

                temps[index].loading = true
                setData(temps)
                temps = data.slice()
                dataProvider('UPDATE', "infochannels", {
                    id: data[index].id,
                    data: {
                        name: temps[index].editName
                    }
                })
                    .then(() => {
                        temps[index].name = temps[index].editName
                        delete temps[index].editName
                        temps[index].edit = false
                        delete temps[index].loading
                        setData(temps)

                    })
                    .catch(error => {
                        delete temps[index].loading
                        if (error.message === 'exist')
                            temps[index].error = 'name exist'
                        else
                            temps[index].error = 'rename failed'
                        setData(temps)
                    })
            }



        }
    }



    const onChangeText = (event, index) => {

        let temps = data.slice()
        if (event.target.value.length === 0)
            temps[index].error = 'required'
        else
            delete temps[index].error
        temps[index].editName = event.target.value
        setData(temps)
    }

    const goToDetail = (index) => {
        setOpenDetail({
            status: true,
            data: data[index]

        })
    }

    const getListInfoChannels = () => {
        dataProvider('GET_LIST', "infochannels", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setData(data);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }

    React.useEffect(() => {
        setLoading(true)
        dataProvider('GET_ONE', `infochannels/findbycluster`, {
            id: clusterData.id
        })
            .then(({ data }) => {
                if (data.length === 0)
                    getListInfoChannels()
                else {
                    setData(data);
                    setLoading(false);
                }

            })
            .catch(error => {
                setLoading(false);
            })

    }, [openDetailInfoChannel])

    const readOnlyClusterInfoChannelAdmin = () => {
        if (!permissions.functionAction.find(value => value.function === 'Cluster Info Channel Admin' && value.isUpdate)) return true
        return false
    }

    const permissionCreateInfoChannel = () => {
        if (!permissions.functionAction.find(value => value.function === 'Info channel (Management)' && value.isUpdate)) return true
        return false
    }
    const handleLink = (item) => {
        history.push(`/infochannel/${item}`)
    }

    if (loading) return <Loading />
    return (
        <Box width='100%' px={2}>
            <Box width='100%' display='flex'>
                <Box flexGrow={1}>
                    <Typography variant='body1'>{translate(`pos.channels.channelNameTitle`)}</Typography>
                </Box>
                <Box hidden={permissionCreateInfoChannel()}>
                    <Box my='auto' component={Button} style={{ textTransform: 'none' }} fontWeight='bold'>
                        <Box my='auto' component={Link} to={'/InfoChannel/create'} style={{ textTransform: 'none', textDecoration: 'none' }} fontWeight='bold'>
                            <Typography variant="subtitle2" style={{ fontWeight: 'bold' }} color="textPrimary">
                                {translate(`pos.channels.addNewChannel`)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box>
                {
                    data.map((item, index) => (
                        <Box key={'channel' + index} display='flex' px={3} py={2} mt={1} bgcolor='white' >
                            <Box flexGrow={1} display='flex' alignItems='center'>
                                {
                                    item.edit ?
                                        (
                                            <Box display='flex'>
                                                <TextField
                                                    disabled={item.loading}
                                                    error={item.error !== undefined}
                                                    helperText={item.error}
                                                    onKeyDown={(event) => {
                                                        event.key === 'Enter' && (handleOutFocus(item.editName, index))
                                                    }}
                                                    value={item.editName}
                                                    onChange={(event) => onChangeText(event, index)}
                                                    autoFocus={true} id="standard-basic" />
                                                <Box ml={2} display='flex' height={25}>
                                                    <Button
                                                        disabled={item.loading}
                                                        size='small'
                                                        style={{ height: 25 }}
                                                        color='primary'
                                                        onClick={() => handleOutFocus(item.editName, index)}
                                                        variant='contained'>
                                                        {item.loading ? (
                                                            <CircularProgress
                                                                size={15}
                                                                thickness={2}
                                                                color='inherit'
                                                            />
                                                        ) :
                                                            translate(`pos.common.save`)
                                                        }
                                                    </Button>
                                                    <Box ml={1} display='flex' alignItems='flex-end'>
                                                        <Typography variant='subtitle2' color='primary'
                                                            style={{ cursor: 'pointer', verticalAlign: 'bottom' }}
                                                            onClick={() => onCancel(index)}>
                                                            {translate(`pos.common.cancel`)}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                            </Box>
                                        )
                                        :
                                        (
                                            readOnlyClusterInfoChannelAdmin() ?
                                                <Typography
                                                    style={{ cursor: 'pointer', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'pre', width: '850px' }}
                                                    color='primary'
                                                    variant='body1'>
                                                    <b>{item.name}</b>
                                                </Typography> :
                                                <Typography onClick={() => goToDetail(index)}
                                                    style={{ cursor: 'pointer', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'pre', width: '850px' }}
                                                    color='primary'
                                                    variant='body1'>
                                                    <b>{item.name}</b>
                                                </Typography>
                                        )
                                }

                            </Box>
                            <Box display='flex'>
                                <Box hidden={readOnlyClusterInfoChannelAdmin()} mr={2}>
                                    <Button onClick={() => goToDetail(index)} variant='contained' color='primary'>{translate(`pos.channels.useIn`)}</Button>
                                </Box>
                                <Box hidden={readOnlyClusterInfoChannelAdmin()} mr={2}>
                                    <Button disabled={item.edit} variant='contained' color='primary' onClick={() => handleClickReName(item.name, index)}>
                                        {translate(`pos.common.rename`)}
                                    </Button>
                                </Box>
                                <Box hidden={readOnlyClusterInfoChannelAdmin()}>
                                    <IconRadiusButton onClick={() => {
                                        setOpenConfirmDialog({
                                            status: true,
                                            index: index
                                        })
                                    }} style={{ width: 30, height: 30, padding: 0 }} bgColor={colors.lightBlue['100']}>
                                        <img src={Delete} width={15}></img>
                                    </IconRadiusButton>

                                </Box>

                            </Box>
                        </Box>
                    ))
                }

            </Box>
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={handleOnDelete}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={'Delete info channel'} />

        </Box >
    )
}
export default InfoChannels